









import {Component, Vue} from 'vue-property-decorator';
import { Inject } from 'vue-typedi';
import { OrderService } from '@/services/OrderService';
import HistorySearchForm from "@/components/history/HistorySearchForm.vue";
import HistoryResultsList from './HistoryResultsList.vue';
import { Order } from '@/model/Order';
import { EventBus } from '@/helpers/EventBus';
import { HistoryFilterRequest } from '@/model/history/HistoryFilterRequest';
import { OrderState } from '@/model/OrderState';
import { HistoryOrdersList } from '@/model/history/HistoryOrdersList';
import { StoreService } from '@/services/StoreService';

@Component({
  components: {HistorySearchForm, HistoryResultsList}
})
export default class HistoryBody extends Vue {

  @Inject()
  orderService!: OrderService;

  @Inject()
  storeService!: StoreService;

  private filters: HistoryFilterRequest = new HistoryFilterRequest();
  private fullOrdersList: Order[] = [];
  private historyOrdersList: HistoryOrdersList = new HistoryOrdersList(this.filters, []);

  created() {
    this.storeService.refreshStore();

    EventBus.$on(EventBus.HISTORY_FILTER_CHANGE, this.onHistoryFilterChange);
    EventBus.$on(EventBus.HISTORY_SEARCH_TERMS_CHANGE, this.onHistorySearchTermsChange);
    EventBus.$on(EventBus.HISTORY_EXPORT, this.onHistoryExport);
    EventBus.$on(EventBus.REFRESH_STORE,  this.refreshHistory);
  }

  beforeDestroy() {
    EventBus.$off(EventBus.HISTORY_FILTER_CHANGE, this.onHistoryFilterChange);
    EventBus.$off(EventBus.HISTORY_SEARCH_TERMS_CHANGE, this.onHistorySearchTermsChange);
    EventBus.$off(EventBus.HISTORY_EXPORT, this.onHistoryExport);
    EventBus.$off(EventBus.REFRESH_STORE,  this.refreshHistory);
  }

  private onHistoryFilterChange(filters: any) {
    if (!filters) {
      return;
    }

    this.filters.startDate = filters.startDate;
    this.filters.endDate = filters.endDate;
    this.filters.status = filters.status;
    this.filters.driveIds = filters.driveIds;

    this.refreshHistory();
  }

  private onHistorySearchTermsChange(searchTerms: string) {
    this.filters.searchTerms = searchTerms;

    const filteredOrdersList = this.filterOrders(this.fullOrdersList, this.filters.searchTerms);
    this.historyOrdersList = new HistoryOrdersList(this.filters, filteredOrdersList);
  }

  private onHistoryExport() {
    this.exportHistoryAsCsv();
  }

  private refreshHistory() {
    this.orderService.getArchivedOrders(this.filters.startDate.format('YYYY-MM-DD'),
                                        this.filters.endDate.format('YYYY-MM-DD'),
                                  this.filters.status ? OrderState[this.filters.status].toString() : null,
                                        this.filters.driveIds)
                      .then(res => {
                          this.fullOrdersList = res;
                          const filteredOrdersList = this.filterOrders(this.fullOrdersList, this.filters.searchTerms);
                          this.historyOrdersList = new HistoryOrdersList(this.filters, filteredOrdersList);
                      });
  }

  private exportHistoryAsCsv() {
    const startDate = this.filters.startDate.format('YYYY-MM-DD');
    const endDate = this.filters.endDate.format('YYYY-MM-DD');
    const status = this.filters.status ? OrderState[this.filters.status].toString() : null;
    const driveIds = this.filters.driveIds;
    const searchTerms = this.filters.searchTerms;

    const fileName = "commandes" + (status === null ? '' : `${this.filters.status === OrderState.DELIVERED ? '_traitées' : '_non_traitées'}`) + `_du_${startDate}_au_${endDate}.csv`;

    this.orderService.getArchivedOrdersAsCsv(startDate, endDate, status, searchTerms, driveIds)
                      .then((response: Blob) => {
                        var fileURL = window.URL.createObjectURL(response);
                        var fileLink = document.createElement('a');

                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', fileName);
                        document.body.appendChild(fileLink);

                        fileLink.click();
                      });
  }

  private filterOrders(fullOrdersList: Order[], searchTerms: string): Order[] {
      const searchInput: string = (searchTerms == null || searchTerms === '') ? null : searchTerms.toLowerCase();

      if (!fullOrdersList || fullOrdersList.length === 0) {
        return [];
      }

      if (!searchInput) {
        return [...fullOrdersList];
      }

      const matchesOrderNumber = (order: Order) => order != null && order.orderNumber != null && order.orderNumber.includes(searchInput);
      const matchesProductCug = (order: Order) => order != null && order.products != null && order.products.find(p => p.cug != null && p.cug.includes(searchInput));

      return fullOrdersList.filter((order: Order) => matchesOrderNumber(order) || matchesProductCug(order));
  }
}
